var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"promo-faq",attrs:{"id":"faq"}},[_c('h2',{staticClass:"title"},[_vm._v(" Вопросы и ответы ")]),_vm._l((_vm.items),function(item,i){return _c('Spoiler',{key:i,attrs:{"title":item.question,"id":'promo-faq-spoiler-' + i}},[_c('p',[_vm._v(" "+_vm._s(item.answer)+" ")])])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }